import React from "react";

import { ReaderContext } from "@PublicationReader/context";

export const Logo = () => {
  const { isEnglish } = React.useContext(ReaderContext);
  const baseUrl = import.meta.env.PROD ? import.meta.env.BASE_URL : "";

  return (
    <img
      src={
        isEnglish
          ? `${baseUrl}/images/pubr-logo-en.png`
          : `${baseUrl}/images/pubr-logo.png`
      }
      className="pubr-reader__logo"
      alt={
        isEnglish
          ? "The Public Health Agency of Sweden"
          : "Folkhälsomyndigheten"
      }
    />
  );
};
